import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5ced01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "more-info-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, " 共享管理服务 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-item-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Samba服务"),
  /*#__PURE__*/_createElementVNode("p", null, "开启之后，支持同网络上传功能使用Samba协议。")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-item-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "匿名访问Samba权限"),
  /*#__PURE__*/_createElementVNode("p", null, "开启之后，其他支持Samba协议的设备无需用户名&密码登录，即可在局域网中访问迅雷盒子设备。通过Samba访问时，允许写入内容、上传、删除、改名等。")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-item-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Samba用户名&密码"),
  /*#__PURE__*/_createElementVNode("p", null, "温馨提示：修改Samba密码后，如果您的电脑端没有生效，请手动清理您的电脑端Samba缓存(在电脑端命令行中执行命令：net use */del/y)")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title margin-top-10" }, " 转码管理服务 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-item-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "开机自启转码服务"),
  /*#__PURE__*/_createElementVNode("p", null, "开启转码服务后，将跟随设备开机自动启动此功能。")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title margin-top-10" }, " 备份服务 ", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "内置磁盘文件备份到云备份空间", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开启备份功能后，内置磁盘文件将全部备份到云备份空间，保障文件数据的安全，防止重要文件丢失。", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["disabled"]

import { reactive, watchEffect, onMounted } from 'vue'
import { useStore } from 'vuex'
import Page from '@remote/components/layout/SubPage.vue'
import MoreInfoItem from '@remote/components/MoreInfoItem.vue'
import Switch from '@remote/components/switchbox/Switch.vue'
import { useHeziSettingsStore } from '@remote/store/settings'
import { checkState } from '@remote/store/utils'
import Modal from '@remote/components/modal'
import { toast } from '@remote/utils/dialog'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const {
  state: heziSettingsState,
  smbAccount: smbAccountState,
  toggleSetHeziService,
  updateSMBAccount,
  refreshSettings,
  heziVip,
} = useHeziSettingsStore()

const serviceConfig = reactive(heziSettingsState)
const smbAccount = reactive(smbAccountState)
let timer: NodeJS.Timeout

watchEffect(() => {
  serviceConfig.isAutoRunSmb = heziSettingsState.isAutoRunSmb,
  serviceConfig.isSmbAllowAnonymous = heziSettingsState.isSmbAllowAnonymous,
  serviceConfig.isAutoRunThumb = heziSettingsState.isAutoRunThumb
  serviceConfig.isAutoRunBacker = heziSettingsState.isAutoRunBacker
})

watchEffect(() => {
  smbAccount.username = smbAccountState.username
  smbAccount.password = smbAccountState.password
})

onMounted(() => {
  refreshSettings()
})

const handleOnSetSMBUser = () => {
  Modal.rename({
    title: '设置Samba',
    maskClosable: true,
    callback: (form: { username: { value: string }; password: { value: string } }) => {
      if (checkState(true, true, false)) return Promise.resolve(false)
      return updateSMBAccount({ username: form.username.value, password: form.password.value })
        .then(() => {
          toast({type: 'success', message: '用户名&密码设置成功'})
          return Promise.resolve(true)
        }).catch(err => {
          toast({type: 'error', message: err || '用户名&密码设置失败'})
          return Promise.resolve(false)
        })
    },
    isSelect: true,
    form: [
      {
        name: 'username',
        label: '用户名',
        placeholder: '请输入用户名',
        defaultValue: smbAccount.username,
      },
      {
        name: 'password',
        label: '密码',
        placeholder: '请输入密码',
        defaultValue: smbAccount.password,
      },
    ],
  })
}

const handleOnToggleSetting = (key: keyof typeof serviceConfig) => {
  const callback = () => {
    if (checkState(true, false, false)) return serviceConfig[key] = !!serviceConfig[key]
    serviceConfig[key] = !serviceConfig[key]
    console.log('handleOnToggleSetting', key, serviceConfig[key])
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      toggleSetHeziService(key, serviceConfig[key])
        .then(() => {
          // 关闭匿名访问，且未设置账号则自动弹出设置账号
          if (key === 'isSmbAllowAnonymous' && !serviceConfig[key] && !smbAccount.username) {
            handleOnSetSMBUser()
          }
        }).catch((err) => {
          toast({type: 'success', message: err || '设置失败'})
        })
    }, 1500)
  }
  if (key === 'isAutoRunBacker' && serviceConfig[key]) {
    Modal.show({
      title: '确定关闭备份功能吗？',
      content: '关闭备份功能，内置磁盘的文件将不再自动备份到云备份空间，磁盘损坏将存在数据丢失的风险。',
      actions: [{
        id: 'closeAutoRunBacker',
        text: '关闭备份',
        callback,
      }],
    })
  } else {
    callback()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, { title: "服务设置" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(MoreInfoItem, null, {
          title: _withCtx(() => [
            _hoisted_3
          ]),
          arrow: _withCtx(() => [
            _createElementVNode("div", {
              class: "set-setting-item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOnToggleSetting('isAutoRunSmb')))
            }, [
              _createVNode(Switch, {
                value: _unref(serviceConfig).isAutoRunSmb
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        (_unref(serviceConfig).isAutoRunSmb)
          ? (_openBlock(), _createBlock(MoreInfoItem, { key: 0 }, {
              title: _withCtx(() => [
                _hoisted_4
              ]),
              arrow: _withCtx(() => [
                _createElementVNode("div", {
                  class: "set-setting-item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOnToggleSetting('isSmbAllowAnonymous')))
                }, [
                  _createVNode(Switch, {
                    value: _unref(serviceConfig).isSmbAllowAnonymous
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(serviceConfig).isAutoRunSmb && !_unref(serviceConfig).isSmbAllowAnonymous)
          ? (_openBlock(), _createBlock(MoreInfoItem, {
              key: 1,
              onClick: handleOnSetSMBUser
            }, {
              title: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createVNode(MoreInfoItem, null, {
          title: _withCtx(() => [
            _hoisted_7
          ]),
          arrow: _withCtx(() => [
            _createElementVNode("div", {
              class: "set-setting-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleOnToggleSetting('isAutoRunThumb')))
            }, [
              _createVNode(Switch, {
                value: _unref(serviceConfig).isAutoRunThumb
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _hoisted_8,
        _createVNode(MoreInfoItem, null, {
          title: _withCtx(() => [
            _createElementVNode("div", {
              class: "setting-item-title",
              disabled: !_unref(heziVip).isvip
            }, _hoisted_12, 8, _hoisted_9)
          ]),
          arrow: _withCtx(() => [
            _createElementVNode("div", {
              class: "set-setting-item",
              disabled: !_unref(heziVip).isvip,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleOnToggleSetting('isAutoRunBacker')))
            }, [
              _createVNode(Switch, {
                value: _unref(serviceConfig).isAutoRunBacker
              }, null, 8, ["value"])
            ], 8, _hoisted_13)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})